module.exports = __webpack_public_path__ + "img/gameTronos9.7c148d86.jpg";